import { useState, useEffect } from 'react';
import { Box, Container, ThemeProvider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NavBar from '../../layout/NavBar';
import { UserApi } from '../../../services/api';
import { useAuth } from '../../context/AuthContext';
import { darkTheme } from '../../../theme/darkTheme';
import { useApiProtectionContext } from '../../context/ApiProtectionContext';
import LoginForm from './components/login/LoginForm';

function LoginDark() {

  const { protect } = useApiProtectionContext();
  const [, setShowNotification] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { login, isLoggedIn, loading: authLoading } = useAuth();

  useEffect(() => {
    // Warte bis loading fertig ist, dann check ob eingeloggt
    if (!authLoading && isLoggedIn) {
      console.log('User ist eingeloggt, redirect zu Dashboard');
      navigate("/dashboard", { replace: true });
    }
  }, [authLoading, isLoggedIn, navigate]);

  const handleLogin = async (email, password) => {
    setMessage({ type: '', text: '' });

    if (!email || !password) {
      setMessage({ type: 'error', text: 'Bitte E-Mail und Passwort eingeben' });
      return;
    }

    setLoading(true);

    try {
      await protect("user-login", async () => {
        const response = await UserApi.login({ email, pw: password });

        login(response.data.nutzer);
        navigate('/dashboard');
      });
    } catch (err) {
      if (err.response?.data?.error) {
        setMessage({ type: 'error', text: err.response.data.error });
      } else {
        setMessage({ type: 'error', text: 'Anmeldung fehlgeschlagen. Bitte versuche es erneut.' });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
        <NavBar />
        <Container maxWidth="sm">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: 'calc(100vh - 64px)',
              py: 3,
            }}
          >
            <LoginForm
              loading={loading}
              message={message}
              onNotificationClose={() => {
                setShowNotification(true);
                setMessage({ type: "", text: "" });
              }}
              onSubmit={handleLogin}
              onForgot={() => navigate('/forgot-password')}
              onRegister={() => navigate('/register')}
            />
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

export default LoginDark;
